const en = {
  navigation: {
    plantHalts: "Fermi impianto"
  }
};

export default { plantHalts: en };
